import script from "./importstudymodel.vue?vue&type=script&setup=true&lang=js"
export * from "./importstudymodel.vue?vue&type=script&setup=true&lang=js"

import "./importstudymodel.vue?vue&type=style&index=0&id=8a09e7d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a09e7d4"]])

export default __exports__